import LiveSessionDeatail from "../ContentManagement/LiveSession/LiveSessionDetail.js/LiveSessionDeatail";

function LactureManagement({ leftSidebarSize }) {
  const localHeader = localStorage.getItem("ActiveBtn");

  return (
    <div>
      <LiveSessionDeatail leftleftSidebarSize={leftSidebarSize} />
    </div>
  );
}

export default LactureManagement;
